<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="活动"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <!-- <el-form-item label="活动类型">
          <el-select
            size="mini"
            v-model="params.ActivityType"
            placeholder="请选择活动类型"
            clearable
          >
            <el-option :value="0" label="线下活动"></el-option>
            <el-option :value="1" label="活动介绍"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="活动名称">
          <el-input
            size="mini"
            v-model="params.ActivityName"
            placeholder="请输入活动名称"
            clearable
          />
        </el-form-item>
        <!-- <el-form-item label="首页展示">
          <el-select
            size="mini"
            v-model="params.ShowIndex"
            placeholder="请选择首页展示"
            clearable
          >
            <el-option :value="1" label="是"></el-option>
            <el-option :value="0" label="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="首页固定展示" label-width="110px">
          <el-select
            size="mini"
            v-model="params.ShowEnd"
            placeholder="首页固定展示"
            clearable
          >
            <el-option :value="1" label="是"></el-option>
            <el-option :value="0" label="否"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="状态">
          <el-select
            size="mini"
            v-model="params.State"
            placeholder="请选择状态"
            clearable
          >
           <el-option label="草稿" :value="0"></el-option>
            <el-option label="待审" :value="1"></el-option>
            <el-option label="通过" :value="2"></el-option>
            <el-option label="不通过" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动状态">
          <el-select
            size="mini"
            v-model="params.ActivityState"
            placeholder="请选择活动状态"
            clearable
          >
            <el-option label="报名中" :value="3"></el-option>
            <el-option label="未开始" :value="0"></el-option>
            <el-option label="进行中" :value="1"></el-option>
            <el-option label="已结束" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="PersonName" label="发布人">
          <template slot-scope="{ row }">
            <span v-if="row.PersonName">{{ row.PersonName }}</span>
            <span v-else>平台</span>
          </template>
        </el-table-column>
        <el-table-column prop="ActivityName" label="活动名称" />
        <!-- <el-table-column prop="ShowIndex" label="首页展示">
          <template slot-scope="{ row }">
            <span v-if="row.ShowIndex == 0">否</span>
            <span v-else-if="row.ShowIndex == 1">是</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="ShowEnd" label="首页固定展示">
          <template slot-scope="{ row }">
            <span v-if="row.ShowEnd == 0">否</span>
            <span v-else-if="row.ShowEnd == 1">是</span>
            <span v-else></span>
          </template>
        </el-table-column> -->
        <el-table-column prop="EnrollNumber" label="可报名总人数" />
        <el-table-column prop="EnrollCount" label="已报名总人数">
          <template slot-scope="{ row }">
            <el-link type="primary" @click="toPage(row)">{{
              row.EnrollCount
            }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="BeginTime" label="开始时间">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toDatetimeString(row.BeginTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="EndTime" label="结束时间">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toDatetimeString(row.EndTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="EnrollEndtime" label="报名截止时间">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toDatetimeString(row.EnrollEndtime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="State" label="状态">
          <template slot-scope="{ row }">
            <el-tag size="small" type="info" v-if="row.State == 0">草稿</el-tag>
            <el-tag size="small" type="primary" v-else-if="row.State == 1"
              >待审</el-tag
            >
            <el-tag size="small" type="success" v-else-if="row.State == 2"
              >审核通过</el-tag
            >
            <el-tag size="small" type="danger" v-else-if="row.State == 3"
              >不通过</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="State" label="活动状态">
          <template slot-scope="{ row }">
            <span>{{ actState(row) }}</span>
          </template>
        </el-table-column>

        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
  <script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/operate/activity").default,
      params: {
        //查询条件使用到的字段就需要写在这里
        TermName: "",
        IfAgreen: null,
        IfControlTime: null,
        State: null,
        ActivityState: null,
      },
    };
  },
  mounted() {
    if (this.$route.query.state == 0) {
      this.params.State = 1;
      this.query(this.params);
    }
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    actState(row) {
      // console.log(row);
      if (row.State == 2) {
        if (row.BeginTime && row.EndTime && row.EnrollEndtime) {
          var dt = new Date();
          var time1 = new Date(row.BeginTime);
          var time2 = new Date(row.EndTime);
          var time3 = new Date(row.EnrollEndtime);
          if (time3 > dt) {
            return "报名中";
          } else if (time1 > dt) {
            return "未开始";
          } else if (time1 <= dt && dt <= time2) {
            return "进行中";
          } else {
            return "已结束";
          }
        }
      }
      // else if (row.State == 0) {
      //   return "未审核";
      // } else if (row.State == 2) {
      //   return "不通过";
      // }
    },
    toPage(data) {
      var params = {
        ActivityId: data.RecordId,
      };
      this.$router.push({ name: "activityenroll", params: params });
    },
  },
};
</script>
  <style lang="scss">
.el-form-item .el-form-item__content .long-inp {
  width: 200px !important;
  .el-input__inner {
    width: 200px;
  }
}
</style>